export const DEFAULT_LOCALE = "ko";
export const SUPPORTED_LOCALES = ["ko", "vi"];
const LOCALE_STORAGE_KEY = "disparty_locale";

export function isSupportedLocale(locale) {
  return SUPPORTED_LOCALES.includes((locale || "").toLowerCase());
}

export function normalizeLocale(locale) {
  const normalized = (locale || "").toLowerCase();
  return isSupportedLocale(normalized) ? normalized : DEFAULT_LOCALE;
}

export function getLocaleFromPathname(pathname) {
  const firstSegment = (pathname || "")
    .split("/")
    .filter(Boolean)[0];

  if (isSupportedLocale(firstSegment)) {
    return normalizeLocale(firstSegment);
  }

  return getSavedLocale();
}

export function withLocale(path, locale = DEFAULT_LOCALE) {
  const safeLocale = normalizeLocale(locale);
  const rawPath = path || "/";
  const normalizedPath = rawPath.startsWith("/") ? rawPath : `/${rawPath}`;
  const cleanPath = normalizedPath === "/" ? "" : normalizedPath;

  if (cleanPath.startsWith("/ko/") || cleanPath.startsWith("/vi/") || cleanPath === "/ko" || cleanPath === "/vi") {
    return cleanPath || `/${safeLocale}`;
  }

  return cleanPath ? `/${safeLocale}${cleanPath}` : `/${safeLocale}`;
}

export function getSavedLocale() {
  if (typeof window === "undefined") return DEFAULT_LOCALE;

  try {
    const saved = window.localStorage.getItem(LOCALE_STORAGE_KEY);
    return normalizeLocale(saved);
  } catch (error) {
    return DEFAULT_LOCALE;
  }
}

export function setSavedLocale(locale) {
  if (typeof window === "undefined") return;

  const safeLocale = normalizeLocale(locale);
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, safeLocale);
  } catch (error) {
    // ignore storage errors
  }
}
